import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ERROR_MESSAGE, notificatonActionEnum } from "utils/const";
import ProfileMenu from "../../../components/profile-menu";
import Loader from "../../../components/shared/loader";
import { storeUserProfileData } from "../../../core/redux/profile/profileSlice";
import LocalStorageService from "../../../core/services/local-storage-service";
import { getAccountsUrl } from "../../../utils/accountsUrl";
import { allApi } from "../../../utils/config";
import { CLOUDINARY_COMPLIANCE_BASE_URL } from "../../../utils/enum";
import { getIntelAccountsUrl } from "../../../utils/intelAccountsUrl";
import { getPaymentsUrl } from "../../../utils/paymentsUrl";
import { getSupplyChainUrl } from "../../../utils/supplyChainUrl";
import { getTradeMapUrl } from "../../../utils/tradeMapUrl";
import { storeUserPlansData } from "../../redux/profile/plansSlice";
import axios from "../../services/axios";
import CreditsPopup from "./creditsPopup";
import ProductLinkingDropdown from "./header-product-linking-dropdown";
import { captureException } from "@sentry/react";
import { setAccessKeys, setDisabledKeys, setOnboardingStatus } from "core/redux/userAccess/userAccessSlice";
import { fetchNotifications } from "core/redux/notifications/notificationSlice";
import NotificationModal from "components/notificationModal/notificationModal";
import { isContentDashboardEnabled } from "utils/featureFlags";

let headerRendered = false;

const TCHeader = ({ heading }) => {
  const [loader, setLoader] = useState(false);
  const [isAppsOpen, setIsAppsOpen] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const isSideBarOpen = useSelector((state) => state.sidebar.isOpen);
  const userProfileData = useSelector((state) => state.profiledata.data);
  const plansData = useSelector((state) => state.plansData.data);
  const notificationData = useSelector((state) => state.notifications.notificationsData);
  const localStorageService = LocalStorageService.getService();
  const notificationRef = useRef(null);

  const dispatch = useDispatch();
  const dropdownRef = useRef(null);

  const callGetPlansByUserId = () => {
    setLoader(true);
    axios
      .post(allApi.getPlansByUserId)
      .then((res) => {
        if (res && res?.data && res?.data?.status.toLowerCase() === "success") {
          dispatch(storeUserPlansData(res.data));
          let userData = localStorageService.getUserData();
          userData.freeTrial = res.data.data[0]?.is_free_trial;
          userData.planID = res?.data?.data?.[0]?.plan_id;
          localStorageService.setDataToLocalStorage("userData", userData);
          if (res.data?.data[0]?.navigate.toLowerCase() === "upgrade") {
            callNavigation("plans");
          }
        }
      })
      .catch(() => {
        toast.error(ERROR_MESSAGE);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getRoleModulesAccess = async () => {
    try {
      const { data } = await axios.get(allApi.getRoleModulesAccess, {
        params: {
          product_name: "trade_reference",
        },
      });
      if (data.access_keys) {
        dispatch(setAccessKeys(data.access_keys));
        dispatch(setDisabledKeys(data.disabled_keys));
        dispatch(setOnboardingStatus(data?.onboarding_status || {}));
      }
    } catch (err) {
      toast.error(ERROR_MESSAGE);
      captureException(err);
    }
  };

  const callProfileDetailsApi = () => {
    setLoader(true);
    axios
      .get(allApi.getUserProfile)
      .then((res) => {
        if (res && res.data) {
          const userData = {
            full_name: res.data?.fullName,
            active_status: res.data?.isActive,
            email_address: res.data?.email || "",
            leadCameFrom: res.data?.leadCameFrom,
          };
          localStorageService.setDataToLocalStorage("userDetails", userData);
          dispatch(storeUserProfileData(res.data));
          localStorage.setItem("userId", res.data.userId);
          localStorage.setItem("orgId", res.data.organisationId);
          localStorage.setItem("isInternalAdmin", res.data.isInternalAdmin);
          localStorage.setItem("isInternalUser", res.data.isInternalUser);
          localStorage.setItem("isAdmin", res.data.isAdmin);
          localStorage.setItem("productArr", res.data.productArr);
        }
      })
      .catch(() => {
        toast.error(ERROR_MESSAGE);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getIntelUserCreditsByPlan = () => {
    axios
      .get(allApi.getUserCreditsByPlan)
      .then((res) => {
        if (res && res.data) {
          localStorage.setItem("intelUserPlan", JSON.stringify(res?.data?.header));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const callNavigation = (data, redirectionUrl) => {
    let url = "";
    if (data === "plans") {
      url =
        getPaymentsUrl() +
        "payment?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&type=" +
        data +
        `${window.location.pathname.includes("classify") ? "&P=trade-reference" : "&P=landed-cost"}` +
        "&OId=" +
        localStorageService.getOptionId() +
        "&N=" +
        localStorageService.getNavigate();
    } else if (data === "payment-method") {
      url =
        getPaymentsUrl() +
        "payment?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&type=" +
        data +
        `${window.location.pathname.includes("classify") ? "&P=trade-reference" : "&P=landed-cost"}` +
        "&OId=" +
        localStorageService.getOptionId() +
        "&N=" +
        localStorageService.getNavigate();
    } else if (data === "profile") {
      url =
        getAccountsUrl() +
        "accounts?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getSessionExpiryDate() +
        "&type=" +
        data +
        "&P=" +
        localStorageService.getUserProduct() +
        "&OId=" +
        localStorageService.getOptionId() +
        "&N=" +
        localStorageService.getNavigate();
    } else if (data === "trademo-map") {
      url =
        getTradeMapUrl() +
        "?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getExpiryDate() +
        "&Type=D&P=" +
        localStorageService.getUserProduct() +
        "&N=" +
        localStorageService.getNavigate();
    } else if (data === "supply-chain") {
      url =
        getSupplyChainUrl() +
        "?T=" +
        localStorageService.getAccessToken() +
        "&I=" +
        localStorageService.getSessionID() +
        "&D=" +
        localStorageService.getExpiryDate() +
        "&Type=D&P=" +
        localStorageService.getUserProduct() +
        "&N=" +
        localStorageService.getNavigate();
    } else {
      url = !!redirectionUrl ? redirectionUrl : window.location.href;
    }
    window.location.href = url;
  };

  const logoutButtonFunction = () => {
    axios
      .get(allApi.logout)
      .then((res) => {
        if (res.data.status.toLocaleUpperCase() === "success".toLocaleUpperCase()) {
          localStorageService.clearCompleteStorage();
          window.location.href = getIntelAccountsUrl() + "signout";
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(ERROR_MESSAGE);
      });
  };

  useEffect(() => {
    if (!headerRendered) {
      callProfileDetailsApi();
      if (!window?.location?.pathname?.includes("free-trial")) {
        getIntelUserCreditsByPlan();
        callGetPlansByUserId();
      }
      getRoleModulesAccess();
      headerRendered = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://cdn.headwayapp.co/widget.js";
    document.head.appendChild(script);
    var config = {
      selector: ".headway-app-widget-compliance",
      account: "7eAEm7",
    };
    script.onload = function () {
      window.Headway.init(config);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current?.contains(event.target)) {
        setIsAppsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotification(false);
      }
    };

    if (showNotification) {
      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [showNotification]);

  const toggleNotification = () => {
    const newShowState = !showNotification;
    setShowNotification(newShowState);
    if (newShowState) {
      dispatch(fetchNotifications());
    }
  };

  const notificationsUpdate = async (action = notificatonActionEnum.markRead, data) => {
    const payload = {
      action: action,
      notif_id: data ? data.id : "",
    };

    try {
      const res = await axios.post(allApi.markNotificationRead, payload);
      if (res && res.data) {
        setTimeout(() => {
          dispatch(fetchNotifications());
        }, 200);
      }
    } catch (error) {
      captureException(error);
      toast.error(ERROR_MESSAGE);
    }
  };

  const isLandedCost =
    window.location.pathname.includes("landedcostcalculator") || window.location.pathname.includes("compare-tariff") || window.location.search.includes("landedcostcalculator");

  return (
    <>
      <nav
        className={`tw-flex tw-items-center tw-justify-between tw-fixed tw-top-0 !tw-bg-white tw-border-b tw-border-[#e7e7e7] tw-h-[48px] tw-z-50 !tw-px-3 ${
          isSideBarOpen ? "tw-w-[calc(100vw-260px)] tw-ms-[260px]" : "tw-w-[calc(100vw-60px)] tw-ms-[60px]"
        }`}>
        <div className="tw-text-label-lg tw-font-medium">{heading || ""}</div>
        <div className="tw-flex tw-items-center tw-gap-2">
          {isContentDashboardEnabled && (
            <div className={window.location.pathname.toLowerCase().includes("content") ? "nav-item custom-hover px-md-2 product-trends-dropdown active" : "nav-item custom-hover px-md-2 product-trends-dropdown"}>
              <a href={window.location.origin + `/content`} className="nav-link">
                Content Dashboard
              </a>
            </div>
          )}
          {isLandedCost && plansData?.data && <CreditsPopup fetchData={() => callGetPlansByUserId()} data={plansData.data} />}
          {!isLandedCost && (
            <div className="notification-center tw-relative" ref={notificationRef}>
              <div onClick={toggleNotification} className="tw-cursor-pointer">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#98A2B3">
                    <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160ZM480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Z" />
                  </svg>
                </span>
                {notificationData?.unread_count > 0 && (
                  <div className="tw-absolute tw-rounded-full tw-size-4 tw-flex tw-justify-center tw-items-center tw-bottom-3 tw-left-3 tw-font-medium tw-text-[8px] tw-bg-warning-400 tw-text-white">
                    {notificationData?.unread_count > 99 ? "99+" : notificationData?.unread_count}
                  </div>
                )}
              </div>
              {showNotification && (
                <NotificationModal
                  setShowNotification={(value) => setShowNotification(value)}
                  notificationData={notificationData || []}
                  notificationsUpdate={(action, data) => notificationsUpdate(action, data)}
                  unreadCount={notificationData?.unread_count}
                  totalCount={notificationData?.total_count}
                />
              )}
            </div>
          )}
          <div className="tw-relative" ref={dropdownRef}>
            <div
              className="tw-text-label-md tw-flex tw-items-center tw-gap-1 tw-border tw-border-gray-200 tw-px-3 tw-py-1.5 tw-shadow-button_white tw-cursor-pointer tw-rounded-lg"
              onClick={() => setIsAppsOpen(!isAppsOpen)}>
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#101828">
                <path d="M263.79-207.39q-23.44 0-39.92-16.69t-16.48-40.13q0-23.44 16.69-39.92t40.13-16.48q23.44 0 39.92 16.69t16.48 40.13q0 23.44-16.69 39.92t-40.13 16.48Zm216 0q-23.44 0-39.92-16.69t-16.48-40.13q0-23.44 16.69-39.92t40.13-16.48q23.44 0 39.92 16.69t16.48 40.13q0 23.44-16.69 39.92t-40.13 16.48Zm216 0q-23.44 0-39.92-16.69t-16.48-40.13q0-23.44 16.69-39.92t40.13-16.48q23.44 0 39.92 16.69t16.48 40.13q0 23.44-16.69 39.92t-40.13 16.48Zm-432-216q-23.44 0-39.92-16.69t-16.48-40.13q0-23.44 16.69-39.92t40.13-16.48q23.44 0 39.92 16.69t16.48 40.13q0 23.44-16.69 39.92t-40.13 16.48Zm216 0q-23.44 0-39.92-16.69t-16.48-40.13q0-23.44 16.69-39.92t40.13-16.48q23.44 0 39.92 16.69t16.48 40.13q0 23.44-16.69 39.92t-40.13 16.48Zm216 0q-23.44 0-39.92-16.69t-16.48-40.13q0-23.44 16.69-39.92t40.13-16.48q23.44 0 39.92 16.69t16.48 40.13q0 23.44-16.69 39.92t-40.13 16.48Zm-432-216q-23.44 0-39.92-16.69t-16.48-40.13q0-23.44 16.69-39.92t40.13-16.48q23.44 0 39.92 16.69t16.48 40.13q0 23.44-16.69 39.92t-40.13 16.48Zm216 0q-23.44 0-39.92-16.69t-16.48-40.13q0-23.44 16.69-39.92t40.13-16.48q23.44 0 39.92 16.69t16.48 40.13q0 23.44-16.69 39.92t-40.13 16.48Zm216 0q-23.44 0-39.92-16.69t-16.48-40.13q0-23.44 16.69-39.92t40.13-16.48q23.44 0 39.92 16.69t16.48 40.13q0 23.44-16.69 39.92t-40.13 16.48Z" />
              </svg>
              <span className="tw-font-medium tw-text-label-md tw-leading-none">All Apps</span>
            </div>
            {isAppsOpen && (
              <div className="tw-absolute tw-right-0 tw-top-11 tw-shadow-lg tw-bg-white tw-rounded-lg tw-p-1">
                {userProfileData?.parent_product_mapping && (
                  <ProductLinkingDropdown
                    parentProductArr={userProfileData?.parent_product_mapping}
                    callNavigation={(key1, key2) => callNavigation(key1, key2)}
                    email={userProfileData?.email}
                    close={() => setIsAppsOpen(false)}
                  />
                )}
              </div>
            )}
          </div>
          <div className="nav">
            <div className="nav-item notification-container d-flex">
              <img className="notification-bell" src={`${CLOUDINARY_COMPLIANCE_BASE_URL}/v1677740206/intel/icons/campaign_pbixeu.svg`} alt="" />
              <span className="headway-app-widget-compliance"></span>
            </div>
          </div>
          <ProfileMenu userData={userProfileData} navigate={callNavigation} logout={logoutButtonFunction} />
        </div>
      </nav>
      {loader && <Loader />}
    </>
  );
};
export default TCHeader;
